var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isSuperUser ? _c('div', [_c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Participants to be invited to the auction")])]), _c('p', {
    staticClass: "font-weight-light mb-3"
  }, [_vm._v(" Please select participants which will be invited to this auction ")]), _c('a-spin', {
    attrs: {
      "spinning": _vm.loadingParticipants
    }
  }, [_c('div', {}, [_c('a-table', {
    attrs: {
      "columns": _vm.participantColumns,
      "data-source": _vm.participants,
      "pagination": {
        pageSize: 50
      },
      "row-key": function rowKey(record) {
        return record.id;
      },
      "row-selection": {
        selectedRowKeys: _vm.auction.participantIds,
        onChange: _vm.onParticipantSelectionChanged
      }
    },
    scopedSlots: _vm._u([{
      key: "lastLogin",
      fn: function fn(text) {
        return _c('span', {}, [_c('a-tag', {
          attrs: {
            "color": text === null ? 'volcano' : 'green'
          }
        }, [_vm._v(" " + _vm._s(text === null ? 'Logged out' : 'Logged in') + " ")]), _c('br'), _vm._v(" " + _vm._s(text === null ? '' : 'Logged in since:' + text) + " ")], 1);
      }
    }, {
      key: "actions",
      fn: function fn(record) {
        return _c('span', {}, [_c('a-popconfirm', {
          attrs: {
            "title": "Are you sure you want to delete this participant?",
            "ok-text": "Yes",
            "cancel-text": "No"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.deleteParticipant(record.id);
            }
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-x-square align-middle text-gray-6",
          attrs: {
            "title": "Delete participant"
          }
        })])]), _c('router-link', {
          attrs: {
            "to": "/participants/edit/".concat(record.id)
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-edit align-middle text-gray-6",
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "title": "Edit user"
          }
        })])])], 1);
      }
    }], null, false, 2731062217)
  })], 1)])], 1)])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Auction details")])]), _c('a-form-model', {
    ref: "auctionForm",
    attrs: {
      "model": _vm.auction,
      "rules": _vm.rules,
      "form": _vm.form,
      "layout": "vertical"
    },
    on: {
      "submit": _vm.createAuction
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    ref: "auctionFlow",
    attrs: {
      "label": "Auction flow",
      "prop": "flow"
    }
  }, [_c('a-select', {
    model: {
      value: _vm.auction.flow,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "flow", $$v);
      },
      expression: "auction.flow"
    }
  }, _vm._l(_vm.flowTypes, function (type) {
    return _c('a-select-option', {
      key: type.code,
      attrs: {
        "value": type.code
      }
    }, [_vm._v(_vm._s(type.title))]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    ref: "auctionType",
    attrs: {
      "label": "Auction type",
      "prop": "type"
    }
  }, [_c('a-select', {
    model: {
      value: _vm.auction.type,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "type", $$v);
      },
      expression: "auction.type"
    }
  }, _vm._l(_vm.auctionTypes, function (type) {
    return _c('a-select-option', {
      key: type.code,
      attrs: {
        "value": type.code
      }
    }, [_vm._v(_vm._s(type.title))]);
  }), 1)], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Auction name",
      "prop": "name"
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "Type name of the auction"
    },
    model: {
      value: _vm.auction.name,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "name", $$v);
      },
      expression: "auction.name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Auction short name",
      "prop": "shortName"
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "Type short name of the auction"
    },
    model: {
      value: _vm.auction.shortName,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "shortName", $$v);
      },
      expression: "auction.shortName"
    }
  })], 1), _c('a-form-model-item', {
    style: {
      display: 'inline-block'
    },
    attrs: {
      "label": "Auction start",
      "prop": "startDate"
    }
  }, [_c('a-date-picker', {
    attrs: {
      "placeholder": "Select date",
      "valueFormat": "YYYY-MM-DD"
    },
    on: {
      "change": _vm.startDateChanged
    },
    model: {
      value: _vm.auction.startDate,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "startDate", $$v);
      },
      expression: "auction.startDate"
    }
  })], 1), _c('a-form-model-item', {
    style: {
      display: 'inline-block',
      'margin-left': '8px'
    },
    attrs: {
      "label": " ",
      "prop": "startTime"
    }
  }, [_c('a-time-picker', {
    attrs: {
      "format": "HH:mm",
      "valueFormat": "HH:mm"
    },
    on: {
      "change": _vm.startTimeChanged
    },
    model: {
      value: _vm.auction.startTime,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "startTime", $$v);
      },
      expression: "auction.startTime"
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "pull-right",
    style: {
      display: 'inline-block'
    },
    attrs: {
      "label": "Open for (hours)",
      "prop": "duration"
    }
  }, [_c('a-time-picker', {
    attrs: {
      "format": "HH:mm",
      "valueFormat": "HH:mm"
    },
    on: {
      "change": _vm.durationChanged
    },
    model: {
      value: _vm.auction.duration,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "duration", $$v);
      },
      expression: "auction.duration"
    }
  })], 1), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "Allocation volume",
      "prop": "allocationVolume"
    }
  }, [_c('a-input', {
    attrs: {
      "suffix": "MWh/h",
      "placeholder": "Allocation volume"
    },
    model: {
      value: _vm.auction.allocationVolume,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "allocationVolume", $$v);
      },
      expression: "auction.allocationVolume"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    ref: "loadType",
    attrs: {
      "label": "Load type",
      "prop": "load"
    }
  }, [_c('a-select', {
    on: {
      "change": _vm.loadTypeChanged
    },
    model: {
      value: _vm.auction.loadType,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "loadType", $$v);
      },
      expression: "auction.loadType"
    }
  }, _vm._l(_vm.loadTypes, function (type) {
    return _c('a-select-option', {
      key: type.code,
      attrs: {
        "value": type.code
      }
    }, [_vm._v(_vm._s(type.title))]);
  }), 1)], 1)], 1)], 1), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "Min. price",
      "prop": "minPrice"
    }
  }, [_c('a-input', {
    attrs: {
      "suffix": "EUR/MWh",
      "placeholder": "Minimal bid price per MWh"
    },
    model: {
      value: _vm.auction.minPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "minPrice", $$v);
      },
      expression: "auction.minPrice"
    }
  }), _c('span', {
    staticClass: "text-default"
  }, [_vm._v("If no Min. price is set leave the value at 0")])], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "Max. price",
      "prop": "maxPrice"
    }
  }, [_c('a-input', {
    attrs: {
      "suffix": "EUR/MWh",
      "placeholder": "Maximal bid price per MWh"
    },
    model: {
      value: _vm.auction.maxPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "maxPrice", $$v);
      },
      expression: "auction.maxPrice"
    }
  }), _c('span', {
    staticClass: "text-default"
  }, [_vm._v("If no Max. price is set leave the value at 0")])], 1)], 1)], 1), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "Required collateral",
      "prop": "requiredCollateral"
    }
  }, [_c('a-input', {
    attrs: {
      "suffix": "EUR/MWh",
      "placeholder": "Minimum collateral required"
    },
    model: {
      value: _vm.auction.requiredCollateral,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "requiredCollateral", $$v);
      },
      expression: "auction.requiredCollateral"
    }
  }), _c('span', {
    staticClass: "text-default"
  }, [_vm._v("If no collateral is required leave it on 0")])], 1)], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Auction comment"
    }
  }, [_c('a-textarea', {
    attrs: {
      "rows": 4,
      "placeholder": "Message visible to the customer on the auction screen"
    },
    model: {
      value: _vm.auction.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "comment", $$v);
      },
      expression: "auction.comment"
    }
  })], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": _vm.createAuction
    }
  }, [_vm._v("Create auction")])], 1), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h5', {
    staticClass: "mb-4 mt-3"
  }, [_vm._v("Load profile")]), _c('div', {
    staticClass: "mb-10"
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.auction.allocationPattern,
      "rowKey": "hour"
    },
    scopedSlots: _vm._u([{
      key: "hour",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v(" " + _vm._s((text + '').padStart(2, '0')) + " - " + _vm._s((text + 1 + '').padStart(2, '0')) + "h ")]);
      }
    }, {
      key: "volume",
      fn: function fn(text, record) {
        return _c('span', {}, [_c('a-input', {
          attrs: {
            "value": record.volume
          },
          on: {
            "change": function change(event) {
              return _vm.changeAllocationAt(record.hour, event);
            }
          }
        })], 1);
      }
    }], null, false, 3744388899)
  })], 1)])], 1), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('LoadPattern', {
    attrs: {
      "pattern": this.auction.allocationPattern,
      "shouldReact": true
    }
  })], 1)], 1)], 1)], 1)])])], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }